// Language options for patient credentials
// Curated list of commonly used languages

export const LANGUAGE_OPTIONS = [
  {value: "Arabic", label: "Arabic"},
  {value: "Bengali", label: "Bengali"},
  {value: "Chinese", label: "Chinese"},
  {value: "English", label: "English"},
  {value: "French", label: "French"},
  {value: "Hindi", label: "Hindi"},
  {value: "Kannada", label: "Kannada"},
  {value: "Malayalam", label: "Malayalam"},
  {value: "Nepali", label: "Nepali"},
  {value: "Others", label: "Others"},
  {value: "Persian", label: "Persian"},
  {value: "Punjabi", label: "Punjabi"},
  {value: "Sindhi", label: "Sindhi"},
  {value: "Sinhalese", label: "Sinhalese"},
  {value: "Tagalog", label: "Tagalog"},
  {value: "Tamil", label: "Tamil"},
  {value: "Urdu", label: "Urdu"}
].sort((a, b) => a.label.localeCompare(b.label));

// Export valid language values for validation
export const VALID_LANGUAGE_CODES = LANGUAGE_OPTIONS.map(lang => lang.value);
